import qs from 'query-string';

const toQueryString = queryOptions => {
  return qs.stringify(queryOptions);
};

export default toQueryString;
